<!--<div class="pt-5">
  <h3 class="text-center">Dashboard</h3>
</div>
-->
<div class="d-flex text-center py-5 justify-content-center align-items-center avs-dashboard">

  <div class="p-4 card shadow rounded-0 h-100">
    <div class="avs-dashboard-title">
      <h6>Fehlerquote Geräte</h6>
    </div>
    <div *ngIf="!isChartErrorRateDataZero" class="avs-dashboard-canvas">
      <canvas id="canvasErrorRate">{{chartError}}</canvas>
    </div>
    <div *ngIf="isChartErrorRateDataZero" class="mt-4 avs-dashboard-empty-canvas">
      <span class="text-danger mt-4">Keine Daten vorhanden</span>
    </div>
  </div>

  <div class="p-4 card shadow rounded-0 h-100">
    <avs-batterie-diagramm></avs-batterie-diagramm>
  </div>

  <div class="p-4 card shadow rounded-0 h-100">
    <avs-fuellcell-remaining-diagramm></avs-fuellcell-remaining-diagramm>
  </div>

  <div class="p-4 card shadow rounded-0 h-100">
    <div class="avs-dashboard-title">
      <h6>Auslastung</h6>
    </div>
    <div *ngIf="!isChartWorkloadDataZero" class="avs-dashboard-canvas">
      <canvas id="canvasWorkload">{{chartUsed}}</canvas>
    </div>
    <div *ngIf="isChartWorkloadDataZero" class="mt-4 avs-dashboard-empty-canvas">
      <span class="text-danger mt-4">Keine Daten vorhanden</span>
    </div>
  </div>

  <div class="p-4 card shadow rounded-0 h-100">
    <div class="avs-dashboard-title">
      <h6>Zuweisung</h6>
    </div>
    <div *ngIf="!isChartAssignmentDataZero" class="avs-dashboard-canvas">
      <canvas id="canvasAssignment">{{chartAssign}}</canvas>
    </div>
    <div *ngIf="isChartAssignmentDataZero" class="mt-4 avs-dashboard-empty-canvas">
      <span class="text-danger mt-4">Keine Daten vorhanden</span>
    </div>
  </div>

</div>

<!--    <div class="col-md-6 mb-3">
      <div class="p-4 card shadow rounded-0 mh-100 mw-100">
        <h6>Durchschnittliche Betriebszeit</h6>
         <div>
          <canvas id="canvasAverageOperatingTime" class="avs-dashboard-canvas">{{chart}}</canvas>
        </div> 
        <div class="mt-4">
          <span class="text-danger mt-4">Keine Daten vorhanden</span>
        </div>
      </div>
-->